module.exports = __webpack_public_path__ + "static/media/Js.7d81fe42.jpg";